const Download = {
  el: {
    root: document.querySelectorAll('.applications-block__download')
  },

  init() {
    if (this.el.root) {
      this.el.root.forEach((target) => {
        const el = {
          select: target.querySelector<HTMLSelectElement>('.js-download-select'),
          button: target.querySelector<HTMLAnchorElement>('.js-download-btn'),
        }

        el.select.addEventListener('change', (e: Event & { target: HTMLSelectElement }) => {
          el.button.href = e.target.value
          el.button.removeAttribute('disabled')
        })
      })
    }
  }
}

export default Download
